import React, { useEffect, useState } from 'react'
import * as Styles from './index.module'
import {HttpServer} from '@/services/server'

interface AdvertisingType {
    open: boolean
    abtest: boolean
    covera: string
    coverb: string
    defaultcover: string
    linka: string
    linkb: string
    defaulturl: string
}

interface Iself {
    avatar_url: string
    id: number
    nickname: string
    role: string
    sex: string
    staff_name: string
    status: string
    subscribed: number
    telephone_validate: boolean
}

enum Version {
    'a' = 'a',
    'b' = 'b'
}

export function MemberShipAd() {
    const [show, setShow] = useState<boolean>(false)
    const [config, setConfig] = useState<AdvertisingType>()
    const [version, setVersion] = useState<Version>(Version.a)

    useEffect(() => {
        initData()
    }, [])

    const initData = async () => {
        try {
            const account = await getAccount()
            if (account.id % 2 === 0) {
                setVersion(Version.a)
            } else {
                setVersion(Version.b)
            }
            HttpServer.getAdvertisingApi().then((res) => {
                if (res.data.code === 0) {
                    const data: AdvertisingType = res.data.data
                    setConfig(data)
                    if (data.open) {
                        setShow(true)
                    }
                }
             })
        } catch (e) {
            console.log(e)
        }
    }

    const getAccount = (): Promise<Iself> => {
        return new Promise((resolve) => {
            if ((window as any).Session) {
                (window as any).Session.getToken((res) => {
                    const timer = setInterval(() => {
                        if (res) {
                            resolve(res.account)
                            clearInterval(timer)
                        }
                    }, 3e2)
                })
            }
        })
    }

    if (config && show) {
        if (config.abtest) {
            if (version === Version.a) {
                return (
                    <div className={Styles.MemberShipAdWrap} onClick={() => window.location.assign(config.linka)}>
                        <img src={config.covera} alt=""/>
                    </div>
                )
            } else {
                return (
                    <div className={Styles.MemberShipAdWrap} onClick={() => window.location.assign(config.linkb)}>
                        <img src={config.coverb} alt=""/>
                    </div>
                )
            }

        } else {
            return (
                <div className={Styles.MemberShipAdWrap} onClick={() => window.location.assign(config.defaulturl)}>
                    <img src={config.defaultcover} alt=""/>
                </div>
            )
        }
    } else {
        return null
    }
}



// WEBPACK FOOTER //
// ./src/plugins/MemberShipAd/index.tsx